import {
  Tabs, TabList, Tab, TabPanels, TabIndicator,
  TabsProps,
} from "@chakra-ui/react";
import {
  Control, FieldValues, Path, useController,
} from "react-hook-form";

type TabOption = {
  label: string;
  value: string;
};

type ControlledTabsProps<T extends FieldValues> = {
  customTab?: React.FC;
  options: TabOption[];
  control: Control<T>;
  name: Path<T>;
  tabListProps?: object;
} & TabsProps;

export default function ControlledTabs<T extends FieldValues>({
  customTab: CustomTab,
  options,
  control,
  name,
  children,
  tabListProps = {},
  ...rest
}: ControlledTabsProps<T>) {
  const TabComponent = CustomTab || Tab;
  const {
    field: { onChange, value },
  } = useController({ name, control });
  return (
    <Tabs
      isFitted
      variant="indicator"
      width="100%"
      index={options.findIndex((o) => o.value === value)}
      onChange={(index) => {
        onChange({ target: { name, value: options[index].value } } as unknown as React.ChangeEvent<HTMLInputElement>);
      }}
      {...rest}
    >
      <TabList width="50%" {...tabListProps}>
        {options.map((option) => (
          <TabComponent key={option.value}>{option.label}</TabComponent>
        ))}
      </TabList>
      <TabIndicator />
      <TabPanels>{children}</TabPanels>
    </Tabs>
  );
}
